angular.module('picmonicng').component('homeMyStats', {
  templateUrl: '/templates/app/components/home-my-stats/home-my-stats.html',
  bindings: {
    settings: '=',
  },
  controller: [
    'User',
    'Pathways',
    'UserService',
    'SpacedRepSettingsModal',
    'PlaylistService',
    function (User, Pathways, UserService, SpacedRepSettingsModal, PlaylistService) {
      var ctrl = this;
      ctrl.PlaylistService = PlaylistService;

      ctrl.colors = ['#E5E5E5'];
      var labels = ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'];
      var day = new Date().getDay();
      ctrl.date = new Date().getDate();
      ctrl.labels = labels.concat(labels.splice(0, (day + 1) % 7));
      ctrl.currentDayOfMonth = moment().date();

      ctrl.data = [];
      ctrl.filter_options = [];
      ctrl.filter_options = [];

      ctrl.options = {
        animation: {
          duration: 0, // general animation time
        },
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            displayColors: false,
            callbacks: {
              title: function (tooltipItem) {
                switch (tooltipItem[0].label) {
                  case 'Su':
                    return 'Sunday';
                  case 'M':
                    return 'Monday';
                  case 'Tu':
                    return 'Tuesday';
                  case 'W':
                    return 'Wednesday';
                  case 'Th':
                    return 'Thursday';
                  case 'F':
                    return 'Friday';
                  case 'Sa':
                    return 'Saturday';
                }

                return tooltipItem[0].label;
              },
              label: function (context) {
                return (context.parsed.y ? context.parsed.y : '0') + ' Questions';
              },
            },
          },
        },
        scales: {
          y: {
            min: 0,
            grid: {
              color: 'rgba(97, 107, 128, 0.2)',
            },
            ticks: {
              stepSize: 5,
              color: '#E5E5E5',
            },
          },
          x: {
            grid: {
              color: 'rgba(97, 107, 128, 0.2)',
              border: 0,
            },
            ticks: {
              color: '#E5E5E5',
            },
          },
        },
      };
      var created = new Date(parseInt(UserService.user.created_at + '000'));
      var monthIndex = new Date().getMonth();
      var year = new Date().getFullYear();
      ctrl.month = new Date().toLocaleString('default', {
        month: 'long',
      });
      ctrl.dayStart = moment(year + '-' + (monthIndex + 1) + '-01').day();
      ctrl.start = 1;
      if (created.getFullYear() === year && created.getMonth() === monthIndex) {
        ctrl.start = created.getDate();
      }
      ctrl.lastDay = new Date(year, monthIndex + 1, 0).getDate();
      ctrl.hasQuizForDate = function (date) {
        if (!ctrl.stats.daily_quizzes) {
          return false;
        }
        return ctrl.stats.daily_quizzes.indexOf(date) !== -1;
      };

      ctrl.stats = User.getv3({
        resource: 'stats',
        resource_id: 'facts',
        full: 1,
      });

      ctrl.stats.$promise.then(function () {
        ctrl.data = {
          labels: ctrl.labels,
          datasets: [
            {
              data: ctrl.stats.daily_questions,
              backgroundColor: '#00E2AC',
              borderColor: '#00E2AC',
              pointBorderColor: '#fff',
              pointHoverBorderColor: '#00E2AC',
              borderWidth: 0,
              color: '#FFF',
              maxBarThickness: 8,
            },
          ],
        };

        const config = {
          type: 'bar',
          data: ctrl.data,
          options: ctrl.options,
        };

        new Chart(document.getElementById('questionsBarChart'), config);
      });

      ctrl.openSettings = function (tab) {
        SpacedRepSettingsModal.show(tab);
      };

      timezone = moment.tz.guess();
      if (UserService.user.settings && !UserService.user.settings.timezone) {
        UserService.user.settings.timezone = timezone;
      }

      var statTimeFrameStart = null;
      var statTimeFrameEnd = null;

      ctrl.timeFrameStats = {
        plays: 0,
        questions_answered: 0,
        quiz_accuracy: 0,
      };

      ctrl.timeFrames = [
        { label: 'This Week', value: 'This Week' },
        { label: 'Last Week', value: 'Last Week' },
        { label: 'Custom', value: 'Custom' },
      ];

      ctrl.weekdays = [
        {
          label: 'Sunday',
          value: 0,
        },
        {
          label: 'Monday',
          value: 1,
        },
        {
          label: 'Tuesday',
          value: 2,
        },
        {
          label: 'Wednesday',
          value: 3,
        },
        {
          label: 'Thursday',
          value: 4,
        },
        {
          label: 'Friday',
          value: 5,
        },
        {
          label: 'Saturday',
          value: 6,
        },
      ];

      moment.defineLocale('en-edu', {
        week: {
          dow: 1,
        },
      });

      var localLocale = moment().locale('en-edu');
      moment.locale('en');
      ctrl.customEnd = localLocale.endOf('week');
      ctrl.customStart = moment.unix(ctrl.customEnd.unix() - 7 * 86400);

      ctrl.weekStart = ctrl.weekdays[1];
      ctrl.statTimeFrame = ctrl.timeFrames[0];
      ctrl.minDate = new Date(1584601200000);

      ctrl.updateTimeFrameStats = function () {
        moment.updateLocale('en-edu', {
          week: {
            dow: ctrl.weekStart.value,
          },
        });
        var localLocale = moment().locale('en-edu');
        moment.locale('en');
        switch (ctrl.statTimeFrame.value) {
          case 'This Week':
            statTimeFrameEnd = localLocale.endOf('week').unix();
            statTimeFrameStart = statTimeFrameEnd - 7 * 86400;
            break;
          case 'Last Week':
            statTimeFrameEnd = localLocale.endOf('week').unix() - 7 * 86400;
            statTimeFrameStart = statTimeFrameEnd - 7 * 86400;
            break;
          case 'All Time':
            statTimeFrameEnd = null;
            statTimeFrameStart = null;
            break;
          case 'Custom':
            statTimeFrameEnd = moment(ctrl.customEnd).startOf('day').unix() + 86399;
            statTimeFrameStart = moment(ctrl.customStart).startOf('day').unix();
        }
        User.queryv3({
          resource: 'student_data',
          by: 'student',
          start: statTimeFrameStart,
          end: statTimeFrameEnd,
          id: UserService.user.user_id,
        }).$promise.then(function (data) {
          if (!data.length) {
            ctrl.timeFrameStats = { show: 0 };
            return;
          }
          ctrl.timeFrameStats = {
            plays: data[0].times_video_played,
            questions_answered: data[0].questions_answered,
            quiz_accuracy: data[0].quiz_accuracy,
            show: data.length,
          };
        });
      };

      ctrl.updateTimeFrameStats();

      ctrl.sections = Pathways.getv3(function (data) {
        delete data.$promise;
        delete data.$resolved;

        angular.forEach(data, function (section, section_name) {
          if (section_name != '$cancelRequest') {
            ctrl.filter_options.push({
              label: section_name,
              value: section_name,
            });
            if (section_name == 'Courses' && !ctrl.settings.stats.sort) {
              ctrl.settings.stats.sort = ctrl.filter_options[ctrl.filter_options.length - 1];
            }
          }
        });
        if (!ctrl.settings.stats.sort) {
          ctrl.settings.stats.sort = ctrl.filter_options[0];
        }

        ctrl.filter_options.push({
          label: 'My Playlists',
          value: 'playlists',
        });
      });

      ctrl.quizStats = User.getv3({
        resource: 'spacedrep',
        resource_id: 'queue',
      });
    },
  ],
});
